import { createSlice } from "@reduxjs/toolkit";
import { isArrayNullOrUndefined, isNullOrUndefined } from "../utils/utils";

const initialState = {
  data: {},
};

const setClientMetrics = (state, action) => {
  if (isArrayNullOrUndefined(state.data.growezyClientMetrics)) {
    state.data = {
      ...state.data,
      growezyClientMetrics: action.payload,
    };
  }
};

const setClientList = (state, action) => {
  if (isArrayNullOrUndefined(state.data.growezyClientList)) {
    state.data = {
      ...state.data,
      growezyClientList: action.payload,
    };
  }
};

const setPayoutSaleData = (state, action) => {
  if (isNullOrUndefined(state.data.payoutsSaleData)) {
    state.data = {
      ...state.data,
      payoutsSaleData: {
        [action.payload.billId]: action.payload.sales,
      },
    };
  } else
    state.data.payoutsSaleData[action.payload.billId] = action.payload.sales;
};

const setPlansData = (state, action) => {
  if (Array.isArray(action.payload)) state.data.plans = action.payload;
  else {
    if (state.data.plans.some((plan) => plan.id === action.payload.id)) {
      state.action.plans = state.action.plans.map((plan) => {
        if (plan.id === action.payload.id) {
          return action.payload;
        } else {
          return plan;
        }
      });
    } else {
      if (isArrayNullOrUndefined(state.data.plans)) {
        state.data.plans = [action.payload];
      } else {
        state.data.plans = [...state.data.plans, action.payload];
      }
    }
  }
};

const appTempSlice = createSlice({
  name: "appTemp",
  initialState,
  reducers: {
    setPlansDataAction: setPlansData,
    setPayoutSaleDataAction: setPayoutSaleData,
    setClientListAction: setClientList,
    setClientMetricsAction: setClientMetrics,
  },
});

export const {
  setPayoutSaleDataAction,
  setPlansDataAction,
  setClientListAction,
  setClientMetricsAction,
} = appTempSlice.actions;
export default appTempSlice.reducer;
